import { render, staticRenderFns } from "./CaptureImages.vue?vue&type=template&id=2316bafe&scoped=true"
import script from "./CaptureImages.vue?vue&type=script&lang=js"
export * from "./CaptureImages.vue?vue&type=script&lang=js"
import style0 from "./CaptureImages.vue?vue&type=style&index=0&id=2316bafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316bafe",
  null
  
)

export default component.exports